if (window.top.location != window.location) {
  window.top.location = window.location
}
